import {
  Box,
  Button,
  Divider,
  Grid,
  makeStyles,
  Switch,
  Typography,
} from "@material-ui/core";
import { CurrencyField, NumberFormat, PercentageField, SelectField, TextField } from "@roc/ui";
import { observer } from "mobx-react";
import { useStore } from "@roc/client-portal-shared/hooks";
import { compsRecencyOptions } from "../../types/filtersOptions";
import { RangeField } from "../rangeField";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    padding: theme.spacing(2),
    width: "450px"
  },
  applyButton: {
    width: "300px"
  }
}));

interface MoreFiltersProps {
  onApply: () => void;
}

export const MoreFilters = observer(({ onApply }: MoreFiltersProps) => {
  const { compToolStoreV2: compToolStore } = useStore();

  const { compToolFiltersStore } = compToolStore;
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" gridGap="1rem" className={classes.root}>
      <Typography variant='body1' style={{ fontWeight: "bold" }}>
        More Filters
      </Typography>
      <Divider variant="fullWidth" />
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body1">Photos</Typography>
        <Switch
          name="photos"
          color="primary"
          checked={compToolFiltersStore.form.fields.HAS_PHOTOS.values.value?.length === 1}
          onChange={(ev) => compToolFiltersStore.onFieldsChange('HAS_PHOTOS', 'values', ev.target.checked ? ["True"] : ["True", "False"])} />
      </Box>
      <Divider variant="fullWidth" />
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body1">Only within School District</Typography>
        <Switch
          name="onlyWithinSchoolDistrict"
          color="primary"
          checked={compToolFiltersStore.form.fields.SCHOOL_DISTRICT.values.value?.length >= 1}
          onChange={(ev) => compToolFiltersStore.onFieldsChange('SCHOOL_DISTRICT', 'values', ev.target.checked ? compToolFiltersStore.schoolDistricts[0]?.value : [])} />
      </Box>
      <Divider variant="fullWidth" />
      <RangeField label="Price Range" fieldName="PRICE" InputComponent={CurrencyField} />
      <RangeField label="Price/Sq.Ft." fieldName="SQFTPRICE" InputComponent={CurrencyField} />
      <RangeField label="Taxes/Year" fieldName="ASSESSOR_TAX" InputComponent={CurrencyField} />
      <RangeField label="Square Feet" fieldName="AREA" InputComponent={NumberFormat} />
      <RangeField label="Year Built" fieldName="YEARBUILT" InputComponent={NumberFormat} />
      <Divider variant="fullWidth" />
      <Box display="flex" justifyContent="center">
        <Button color="primary" variant="outlined" className={classes.applyButton} onClick={() => onApply && onApply()}>Apply</Button>
      </Box>
    </Box>
  );
});
